export default function ComparisonSection() {
  return (
    <>
      <section id="comparison" className="py-24 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          {/* 見出し */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#8B6BAE]"></span>
              <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">COMPARISON</p>
              <span className="w-12 h-px bg-[#8B6BAE]"></span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              一般的な薄型スタンドケースとの<span className="text-[#8B6BAE]">違い</span>
            </h2>
            <p className="text-base text-[#6B6B6B] font-light">
              汎用性重視の製品とは異なる、描くことに特化した設計思想。
            </p>
          </div>

          {/* 比較テーブル */}
          <div className="bg-white rounded-2xl overflow-hidden border border-[#E8E8E8] mb-16">
            <table className="w-full">
              <thead>
                <tr className="bg-[#8B6BAE]">
                  <th className="py-4 px-6 text-left font-medium text-white text-sm w-1/4">観点</th>
                  <th className="py-4 px-6 text-left font-medium text-white text-sm w-[37.5%]">一般的な薄型スタンドケース</th>
                  <th className="py-4 px-6 text-left font-medium text-white text-sm w-[37.5%]">Atelier Folio</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-[#F0F0F0]">
                  <td className="py-4 px-6 text-[#4A4A4A] text-sm font-medium">主眼</td>
                  <td className="py-4 px-6 text-[#6B6B6B] text-sm">汎用性・携帯性</td>
                  <td className="py-4 px-6 text-[#2C2C2C] text-sm font-medium">描く行為</td>
                </tr>
                <tr className="border-t border-[#F0F0F0]">
                  <td className="py-4 px-6 text-[#4A4A4A] text-sm font-medium">角度思想</td>
                  <td className="py-4 px-6 text-[#6B6B6B] text-sm">視聴・閲覧中心</td>
                  <td className="py-4 px-6 text-[#2C2C2C] text-sm font-medium">描画中心(25°以下)</td>
                </tr>
                <tr className="border-t border-[#F0F0F0]">
                  <td className="py-4 px-6 text-[#4A4A4A] text-sm font-medium">想定ユーザー</td>
                  <td className="py-4 px-6 text-[#6B6B6B] text-sm">幅広い一般ユーザー</td>
                  <td className="py-4 px-6 text-[#2C2C2C] text-sm font-medium">イラストレーター起点</td>
                </tr>
                <tr className="border-t border-[#F0F0F0]">
                  <td className="py-4 px-6 text-[#4A4A4A] text-sm font-medium">構造</td>
                  <td className="py-4 px-6 text-[#6B6B6B] text-sm">貼り付け・はめ込み・簡易スタンド</td>
                  <td className="py-4 px-6 text-[#2C2C2C] text-sm font-medium">折る(Origami構造)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* 下部メッセージ */}
          <div className="text-center space-y-3">
            <p className="text-base text-[#6B6B6B]">
              Atelier Folioは、単なるスタンド付きケースではありません。
            </p>
            <p className="text-lg text-[#2C2C2C] font-medium">
              描く人の道具として設計されたモバイルiPadケーススタンドです。
            </p>
          </div>
        </div>
      </section>

      {/* 本製品の仕様セクション */}
      <section className="py-24 px-6 bg-[#F8F6FA]">
        <div className="max-w-5xl mx-auto">
          {/* 見出し */}
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#8B6BAE]"></span>
              <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">SPECIFICATIONS</p>
              <span className="w-12 h-px bg-[#8B6BAE]"></span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              製品<span className="text-[#8B6BAE]">仕様</span>
            </h2>
            <p className="text-base text-[#6B6B6B] font-light">
              本製品はiPad用です。内蔵マグネットで角度を調整します。
            </p>
          </div>

          {/* 対応機種ビジュアル */}
          <div className="bg-white rounded-2xl p-10 mb-12 border border-[#E8E8E8]">
            <div className="flex flex-wrap justify-center items-end gap-8 mb-6">
              {/* iPad Air */}
              <div className="text-center">
                <div className="w-20 h-24 bg-[#2C2C2C] rounded-lg mb-3 mx-auto relative overflow-hidden">
                  <div className="absolute inset-1 bg-gradient-to-br from-[#93C5FD] to-[#3B82F6] rounded-md"></div>
                </div>
                <p className="text-xs text-[#2C2C2C] font-medium">iPad Air</p>
              </div>
              {/* iPad */}
              <div className="text-center">
                <div className="w-20 h-24 bg-[#2C2C2C] rounded-lg mb-3 mx-auto relative overflow-hidden">
                  <div className="absolute inset-1 bg-gradient-to-br from-[#86EFAC] to-[#22C55E] rounded-md"></div>
                </div>
                <p className="text-xs text-[#2C2C2C] font-medium">iPad</p>
              </div>
              {/* iPad mini */}
              <div className="text-center">
                <div className="w-16 h-20 bg-[#2C2C2C] rounded-lg mb-3 mx-auto relative overflow-hidden">
                  <div className="absolute inset-1 bg-gradient-to-br from-[#FDBA74] to-[#F97316] rounded-md"></div>
                </div>
                <p className="text-xs text-[#2C2C2C] font-medium">iPad mini</p>
              </div>
            </div>
            <p className="text-center text-sm text-[#6B6B6B]">
              本製品はiPad用です。内蔵マグネットで角度を調整します。
            </p>
          </div>

          {/* 仕様テーブル */}
          <div className="space-y-6">
            {/* 対応機種 */}
            <div className="bg-white rounded-2xl p-8 border border-[#E8E8E8]">
              <h3 className="text-base font-medium text-[#2C2C2C] mb-6 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#8B6BAE] rounded-lg">
                  <i className="ri-tablet-line text-white text-sm"></i>
                </div>
                対応機種別仕様
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {/* iPad Air 11インチ */}
                <div className="bg-[#F8F6FA] rounded-xl p-5 border border-[#F0F0F0]">
                  <div className="inline-block px-3 py-1 bg-[#DBEAFE] rounded-full mb-4">
                    <span className="text-xs font-medium text-[#3B82F6]">iPad Air 11"</span>
                  </div>
                  <div className="space-y-2.5">
                    <div className="flex justify-between items-start py-2 border-b border-[#E8E8E8]">
                      <span className="text-sm text-[#6B6B6B]">対応機種</span>
                      <div className="text-sm text-[#2C2C2C] text-right font-medium">
                        <p>11インチ iPad Air</p>
                        <p className="text-xs text-[#8B6BAE] mt-0.5">(M2/M3・第4/5世代)</p>
                      </div>
                    </div>
                    <div className="flex justify-between items-center py-2 border-b border-[#E8E8E8]">
                      <span className="text-sm text-[#6B6B6B]">寸法</span>
                      <span className="text-sm text-[#2C2C2C]">182×18.8×250mm</span>
                    </div>
                    <div className="flex justify-between items-center py-2">
                      <span className="text-sm text-[#6B6B6B]">重量</span>
                      <span className="text-sm text-[#2C2C2C]">358g</span>
                    </div>
                    <div className="pt-2 border-t border-[#E8E8E8] mt-1">
                      <p className="text-[11px] text-[#9B9B9B] leading-relaxed">※ 重量はペンケースを含んだ重さです。</p>
                      <p className="text-[11px] text-[#9B9B9B] leading-relaxed">※ 多少の誤差はあります。</p>
                    </div>
                  </div>
                </div>

                {/* iPad 10.9インチ */}
                <div className="bg-[#F8F6FA] rounded-xl p-5 border border-[#F0F0F0]">
                  <div className="inline-block px-3 py-1 bg-[#DCFCE7] rounded-full mb-4">
                    <span className="text-xs font-medium text-[#22C55E]">iPad 10.9"</span>
                  </div>
                  <div className="space-y-2.5">
                    <div className="flex justify-between items-start py-2 border-b border-[#E8E8E8]">
                      <span className="text-sm text-[#6B6B6B]">対応機種</span>
                      <div className="text-sm text-[#2C2C2C] text-right font-medium">
                        <p>iPad 10.9インチ</p>
                        <p className="text-xs text-[#8B6BAE] mt-0.5">(第10/11世代)</p>
                      </div>
                    </div>
                    <div className="flex justify-between items-center py-2 border-b border-[#E8E8E8]">
                      <span className="text-sm text-[#6B6B6B]">寸法</span>
                      <span className="text-sm text-[#2C2C2C]">184×18.5×252mm</span>
                    </div>
                    <div className="flex justify-between items-center py-2">
                      <span className="text-sm text-[#6B6B6B]">重量</span>
                      <span className="text-sm text-[#2C2C2C]">363g</span>
                    </div>
                    <div className="pt-2 border-t border-[#E8E8E8] mt-1">
                      <p className="text-[11px] text-[#9B9B9B] leading-relaxed">※ 重量はペンケースを含んだ重さです。</p>
                      <p className="text-[11px] text-[#9B9B9B] leading-relaxed">※ 多少の誤差はあります。</p>
                    </div>
                  </div>
                </div>

                {/* iPad Mini */}
                <div className="bg-[#F8F6FA] rounded-xl p-5 border border-[#F0F0F0]">
                  <div className="inline-block px-3 py-1 bg-[#FFEDD5] rounded-full mb-4">
                    <span className="text-xs font-medium text-[#F97316]">iPad Mini</span>
                  </div>
                  <div className="space-y-2.5">
                    <div className="flex justify-between items-start py-2 border-b border-[#E8E8E8]">
                      <span className="text-sm text-[#6B6B6B]">対応機種</span>
                      <div className="text-sm text-[#2C2C2C] text-right font-medium">
                        <p>iPad mini</p>
                        <p className="text-xs text-[#8B6BAE] mt-0.5">(第6/7世代)</p>
                      </div>
                    </div>
                    <div className="flex justify-between items-center py-2 border-b border-[#E8E8E8]">
                      <span className="text-sm text-[#6B6B6B]">寸法</span>
                      <span className="text-sm text-[#2C2C2C]">144×15.2×197mm</span>
                    </div>
                    <div className="flex justify-between items-center py-2">
                      <span className="text-sm text-[#6B6B6B]">重量</span>
                      <span className="text-sm text-[#2C2C2C]">218g</span>
                    </div>
                    <div className="pt-2 border-t border-[#E8E8E8] mt-1">
                      <p className="text-[11px] text-[#9B9B9B] leading-relaxed">※ 重量はペンケースを含んだ重さです。</p>
                      <p className="text-[11px] text-[#9B9B9B] leading-relaxed">※ 多少の誤差はあります。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 素材 */}
            <div className="bg-white rounded-2xl p-8 border border-[#E8E8E8]">
              <h3 className="text-base font-medium text-[#2C2C2C] mb-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#8B6BAE] rounded-lg">
                  <i className="ri-palette-line text-white text-sm"></i>
                </div>
                素材
              </h3>
              <p className="text-sm text-[#4A4A4A]">PUレザー + スエード裏地</p>
            </div>

            {/* 対応機種一覧（詳細） */}
            <div className="bg-white rounded-2xl p-8 border border-[#E8E8E8]">
              <h3 className="text-base font-medium text-[#2C2C2C] mb-2 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#8B6BAE] rounded-lg">
                  <i className="ri-tablet-line text-white text-sm"></i>
                </div>
                対応機種一覧
              </h3>
              <p className="text-xs text-[#9B9B9B] mb-6 pl-11">お使いのiPadが対応しているかご確認ください。</p>

              <div className="space-y-6">
                {/* iPad Air シリーズ */}
                <div className="bg-[#F8F6FA] rounded-xl border border-[#F0F0F0] overflow-hidden">
                  <div className="px-5 py-3.5 border-b border-[#F0F0F0] flex items-center gap-2.5">
                    <span className="inline-block px-2.5 py-1 bg-[#DBEAFE] rounded-full">
                      <span className="text-[11px] font-semibold text-[#3B82F6]">iPad Air 11&quot;</span>
                    </span>
                    <span className="text-xs text-[#6B6B6B]">— ケースサイズ: 182×18.8×250mm / 358g</span>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="bg-[#F0EBF5]/50">
                          <th className="text-left px-5 py-2.5 text-[#6B6B6B] font-medium">モデル名</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">発売年</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">チップ</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">画面サイズ</th>
                          <th className="text-center px-5 py-2.5 text-[#6B6B6B] font-medium">モデル番号</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { name: "iPad Air（第4世代）", year: "2020", chip: "A14 Bionic", screen: "10.9インチ", model: "A2316 / A2324 / A2325 / A2072" },
                          { name: "iPad Air（第5世代）", year: "2022", chip: "M1", screen: "10.9インチ", model: "A2588 / A2589 / A2591" },
                          { name: "iPad Air 11インチ（M2）", year: "2024", chip: "M2", screen: "11インチ", model: "A2898 / A2899 / A2900 / A2901" },
                          { name: "iPad Air 11インチ（M3）", year: "2025", chip: "M3", screen: "11インチ", model: "A3162 / A3163" },
                        ].map((item, i) => (
                          <tr key={i} className={`border-t border-[#F0F0F0] ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                            <td className="px-5 py-2.5 text-[#2C2C2C] font-medium whitespace-nowrap">{item.name}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.year}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.chip}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.screen}</td>
                            <td className="text-center px-5 py-2.5 text-[#9B9B9B] font-mono text-[11px]">{item.model}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* iPad 10.9 シリーズ */}
                <div className="bg-[#F8F6FA] rounded-xl border border-[#F0F0F0] overflow-hidden">
                  <div className="px-5 py-3.5 border-b border-[#F0F0F0] flex items-center gap-2.5">
                    <span className="inline-block px-2.5 py-1 bg-[#DCFCE7] rounded-full">
                      <span className="text-[11px] font-semibold text-[#22C55E]">iPad 10.9&quot;</span>
                    </span>
                    <span className="text-xs text-[#6B6B6B]">— ケースサイズ: 184×18.5×252mm / 363g</span>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="bg-[#F0EBF5]/50">
                          <th className="text-left px-5 py-2.5 text-[#6B6B6B] font-medium">モデル名</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">発売年</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">チップ</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">画面サイズ</th>
                          <th className="text-center px-5 py-2.5 text-[#6B6B6B] font-medium">モデル番号</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { name: "iPad（第10世代）", year: "2022", chip: "A14 Bionic", screen: "10.9インチ", model: "A2696 / A2757 / A2777" },
                          { name: "iPad A16（11インチ）", year: "2025", chip: "A16 Bionic", screen: "11インチ", model: "A3355 / A3356" },
                        ].map((item, i) => (
                          <tr key={i} className={`border-t border-[#F0F0F0] ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                            <td className="px-5 py-2.5 text-[#2C2C2C] font-medium whitespace-nowrap">{item.name}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.year}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.chip}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.screen}</td>
                            <td className="text-center px-5 py-2.5 text-[#9B9B9B] font-mono text-[11px]">{item.model}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="px-5 py-2.5 bg-[#F0EBF5]/30 border-t border-[#F0F0F0]">
                    <p className="text-[11px] text-[#9B9B9B] flex items-center gap-1.5">
                      <i className="ri-information-line text-[#8B6BAE] text-xs"></i>
                      iPad Air 11インチとiPad 10.9インチは共通サイズのケースです。
                    </p>
                  </div>
                </div>

                {/* iPad mini シリーズ */}
                <div className="bg-[#F8F6FA] rounded-xl border border-[#F0F0F0] overflow-hidden">
                  <div className="px-5 py-3.5 border-b border-[#F0F0F0] flex items-center gap-2.5">
                    <span className="inline-block px-2.5 py-1 bg-[#FFEDD5] rounded-full">
                      <span className="text-[11px] font-semibold text-[#F97316]">iPad Mini</span>
                    </span>
                    <span className="text-xs text-[#6B6B6B]">— ケースサイズ: 144×15.2×197mm / 218g</span>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="bg-[#F0EBF5]/50">
                          <th className="text-left px-5 py-2.5 text-[#6B6B6B] font-medium">モデル名</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">発売年</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">チップ</th>
                          <th className="text-center px-3 py-2.5 text-[#6B6B6B] font-medium">画面サイズ</th>
                          <th className="text-center px-5 py-2.5 text-[#6B6B6B] font-medium">モデル番号</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { name: "iPad mini（第6世代）", year: "2021", chip: "A15 Bionic", screen: "8.3インチ", model: "A2567 / A2568 / A2569" },
                          { name: "iPad mini（第7世代）", year: "2024", chip: "A17 Pro", screen: "8.3インチ", model: "A2995 / A2996" },
                        ].map((item, i) => (
                          <tr key={i} className={`border-t border-[#F0F0F0] ${i % 2 === 0 ? 'bg-white' : 'bg-[#FAFAFA]'}`}>
                            <td className="px-5 py-2.5 text-[#2C2C2C] font-medium whitespace-nowrap">{item.name}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.year}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.chip}</td>
                            <td className="text-center px-3 py-2.5 text-[#4A4A4A]">{item.screen}</td>
                            <td className="text-center px-5 py-2.5 text-[#9B9B9B] font-mono text-[11px]">{item.model}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="mt-5 px-1 space-y-1">
                <p className="text-[11px] text-[#9B9B9B] flex items-center gap-1.5">
                  <i className="ri-information-line text-[#8B6BAE] text-xs"></i>
                  モデル番号はiPad本体の背面または「設定」→「一般」→「情報」から確認できます。
                </p>
                <p className="text-[11px] text-[#9B9B9B] flex items-center gap-1.5">
                  <i className="ri-information-line text-[#8B6BAE] text-xs"></i>
                  重量はペンケースを含んだ重さです。多少の誤差はあります。
                </p>
              </div>
            </div>

            {/* カラー */}
            <div className="bg-white rounded-2xl p-8 border border-[#E8E8E8]">
              <h3 className="text-base font-medium text-[#2C2C2C] mb-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#8B6BAE] rounded-lg">
                  <i className="ri-paint-brush-line text-white text-sm"></i>
                </div>
                カラー
              </h3>
              <div className="space-y-6">
                {/* ケースカラー */}
                <div>
                  <h4 className="text-sm font-medium text-[#2C2C2C] mb-4">ケース</h4>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {[
                      { name: '餅 × バニラ', color1: '#ffffff', color2: '#FFF8DC' },
                      { name: '餅 × トリュフ', color1: '#ffffff', color2: '#69686d' },
                      { name: '餅 × シナモン', color1: '#ffffff', color2: '#af9e8c' },
                      { name: '餅 × モカ', color1: '#ffffff', color2: '#6F4E37' },
                      { name: '墨 × エスプレッソ', color1: '#000000', color2: '#161616' },
                      { name: '墨 × トリュフ', color1: '#000000', color2: '#69686d' },
                      { name: '墨 × シナモン', color1: '#000000', color2: '#af9e8c' },
                      { name: '墨 × モカ', color1: '#000000', color2: '#6F4E37' },
                    ].map((item, index) => (
                      <div key={index} className="bg-[#F8F6FA] rounded-lg p-3 border border-[#F0F0F0]">
                        <div className="flex gap-2 mb-2">
                          <div className="w-7 h-7 rounded-full border border-[#E0E0E0]" style={{ backgroundColor: item.color1 }}></div>
                          <div className="w-7 h-7 rounded-full border border-[#E0E0E0]" style={{ backgroundColor: item.color2 }}></div>
                        </div>
                        <p className="text-xs text-[#2C2C2C]">{item.name}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ペンホルダーカラー */}
                <div>
                  <h4 className="text-sm font-medium text-[#2C2C2C] mb-4">ペンホルダー</h4>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                    {[
                      { name: '餅 × バニラ', color1: '#ffffff', color2: '#FFF8DC' },
                      { name: '餅 × トリュフ', color1: '#ffffff', color2: '#69686d' },
                      { name: '餅 × シナモン', color1: '#ffffff', color2: '#af9e8c' },
                      { name: '餅 × モカ', color1: '#ffffff', color2: '#6F4E37' },
                      { name: '墨 × エスプレッソ', color1: '#000000', color2: '#161616' },
                      { name: '墨 × トリュフ', color1: '#000000', color2: '#69686d' },
                      { name: '墨 × シナモン', color1: '#000000', color2: '#af9e8c' },
                      { name: '墨 × モカ', color1: '#ffffff', color2: '#6F4E37' },
                      { name: '桜 × トリュフ', color1: '#FFB7C5', color2: '#69686d' },
                      { name: '影 × トリュフ', color1: '#696969', color2: '#69686d' },
                    ].map((item, index) => (
                      <div key={index} className="bg-[#F8F6FA] rounded-lg p-3 border border-[#F0F0F0]">
                        <div className="flex gap-2 mb-2">
                          <div className="w-7 h-7 rounded-full border border-[#E0E0E0]" style={{ backgroundColor: item.color1 }}></div>
                          <div className="w-7 h-7 rounded-full border border-[#E0E0E0]" style={{ backgroundColor: item.color2 }}></div>
                        </div>
                        <p className="text-xs text-[#2C2C2C]">{item.name}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* 製造国 */}
            <div className="bg-white rounded-2xl p-8 border border-[#E8E8E8]">
              <h3 className="text-base font-medium text-[#2C2C2C] mb-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#8B6BAE] rounded-lg">
                  <i className="ri-map-pin-line text-white text-sm"></i>
                </div>
                製造
              </h3>
              <p className="text-sm text-[#4A4A4A]">Made in China</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
